import { ref } from '@vue/composition-api';
export const useUpdatesCounter = () => {
    const updatesCounter = ref(0);
    const update = () => updatesCounter.value++;
    return { updatesCounter, update };
};
